import { Vue } from 'vue-class-component';
import { AxiosRequestConfig, AxiosResponse } from 'axios';
import qs from 'qs';
import AppVo from '@/vo/AppVo';
import WxUtil from '@/util/WxUtil';
import UrlUtil from '@/util/UrlUtil';
import wx from 'weixin-js-sdk';
import AppUtil from '@/util/AppUtil';
import TenantVo from '@/vo/TenantVo';
// import {Toast} from 'vant'
/**页面基类*/
export default class BasePage extends Vue {
    //data
    //beforeCreate
    //created
    //beforeMount
    //mounted
    //beforeDestroy
    //destroyed
    //beforeUpdate
    //updated
    //activated-
    //render
    //errorCaptured
    //serverPrefetch
    // title = TenantVo.getInstance().name;
    protected _title="";
    backcolor = "#F6F6F6";

    /**全局数据*/
    protected appVo = AppVo.getInstance();
    /**是否正在登陆，防止重复登陆，并阻断新请求 */
    private islogin = false;
    /**微信jssdk */
    private static wxsdk: any;
    created(): void {
        // console.log("created",this.title);
        
        document.title = this.title;
        console.log("document.title",document.title);
        document.body.style.backgroundColor = this.backcolor;
        // console.log("appid",this.$route.query.appid,UrlUtil.getUrlParam('appid'))
        const appid=this.$route.query.appid||UrlUtil.getUrlParam('appid');
        if(appid){//储存appid
            this.appVo.appid=appid;
            localStorage.setItem("appid",appid);
        }

    }
    get title(){
        if(!this._title){
            this._title=TenantVo.getInstance().name;
        }
        return this._title;
    }
    set title(val){
        this._title!=val&&(this._title=val);
    }
    /**
     * config{
         * method post 或者get
         * url 接口地址
         * params 参数
     *} 
     * sucessFun 访问成功执行的方法
     * loading_tip 加载中的提示文本
     * endFunc 无论成功或者失败，都要执行的方法
     */
    request(config: AxiosRequestConfig, sucessFun: any, loading_tip = "", endFunc: Function | null = null): void {
        if (this.islogin) {
            return;
        }
        if (loading_tip) {
            this.$toast.loading({
                message: loading_tip,
                forbidClick: true,
                duration: 0
            });
        }
        config.data = qs.stringify(config.data);
        this.$axios(config).then((res: AxiosResponse) => {
            this.$toast.clear();
            setTimeout(() => {//防止正常提示被$toast.clear()清除
                const data = res.data;
                if (data.code == 401) {
                    this.$toast(data.msg);
                    WxUtil.wxLogin();
                    // this.$router.push("pwdlogin");
                } else if (data.code != 1) {
                    this.$toast(data.msg);
                } else { //成功
                    sucessFun(data);
                }
                endFunc ? endFunc() : "";
            }, 100);

            // console.log('this.shop_info',this.shop_info);
        }).catch((error: any) => {
            this.$toast.clear();
            // console.log(error);
            setTimeout(() => {//防止提示被$toast.clear()清除
                if (!error.response) {
                    return;
                }
                if (error.response.status == 401) {
                    //先判断是否已经获取到code
                    let code = UrlUtil.getUrlParam("code");
                    code ? this.req_login(code) : WxUtil.wxLogin();
                } else {
                    if (error.response.data && error.response.data.errors) {
                        this.$toast(JSON.stringify(error.response.data.errors));
                    } else {
                        this.$toast(error.message);
                    }
                    endFunc ? endFunc() : "";
                }
            }, 100);
        });
    }

    // private loginUrl="";
    private req_login(code: string) {
        if (this.islogin) {
            return
        }
        this.islogin = true;
        let obj:any={ code: code, domainUrl: document.domain };
        if(localStorage.getItem("tenantId")){
            obj.tenantId=localStorage.getItem("tenantId");
        }
        this.$axios({
            url: "/zhMember/member/getOpenIdAndSessionKey",
            method: "post",
            data: qs.stringify(obj)
        }).then((res: AxiosResponse) => {

            const data = res.data;

            if (data.code != 1) {
                this.$toast(data.msg);
            } else { //成功
                // this.appVo.user = res.data;
                // this.mounted();
                // window.location.reload();
                window.location.href="https://"+window.location.host+"/?appid="+UrlUtil.getUrlParam("appid");
            }
            // this.islogin = false;
        }).catch((error: any) => {

            console.log(error);
            if (!error.response) {
                return;
            }
            if (error.response.data && error.response.data.errors) {
                this.$toast(JSON.stringify(error.response.data.errors));
            } else {
                // console.log("this.$toast( error)",JSON.stringify(error))
                this.$toast(error.message);
            }
            // this.islogin = false;
        });
    }
    /**获取缩略图地址，默认宽高为200*/
    public get_thumb(url: string, w = 200, h = 200): string {
        // http://image-demo.oss-cn-hangzhou.aliyuncs.com/example.jpg?x-oss-process=image/resize,m_fill,h_100,w_100

        return url ? url + "?x-oss-process=image/resize,m_fill,h_" + h + ",w_" + w : "";
    }
    
    /**获取微信jssdk */
    public async get_wx() {
        if (this.wxsdk) {
            return this.wxsdk;
        }
        let wxsdk = await this.init_wx(this.wxsdk);
        return wxsdk;
    }
    /**初始化微信配置 */
    private init_wx(wxsdk: any) {

        return new Promise(resolve => {
            AppUtil.request({
                url: "/zhPay/wxpay/wxH5Share",
                method: "post",
                data: { url: "https://dymy888.cn" }
            }, (res: any) => {
                console.log("/zhPay/wxpay/wxH5Share", res);
                this.wxsdk = wx;

                wx.config({
                    debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: res.data.appId, // 必填，公众号的唯一标识
                    timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                    signature: res.data.signature,// 必填，签名
                    jsApiList: ["chooseWXPay"] // 必填，需要使用的JS接口列表
                });
                resolve(wx);
                // console.log("首页门店信息",res);
                // this.tenantInfo.setData(res.data) ;
            });
        })
    }

}
